import {v4 as uuidv4} from "uuid";
import {faker}  from "@faker-js/faker";
import { users } from "../factories/users";

const allUsers = users();

const permissions = [
  {
    Module: "Operations Access",
    Description:
      "Users in this role will have full access to create tasks and schedule them",
  },
  {
    Module: "Infrastructure Access",
    Description:
      "Users in this role will have full access to view all infrastructure and also perform operations on demand",
  },
];

const allRoles = [
  {
    ID: "c71db059-6b93-4a95-9092-6d22d73a7fc6",
    Name: "Cloud Admin",
    Description:
      "Full access to the organization as managed thru the MontyCloud platform.",
    UsersCount: "3",
    Users: allUsers.slice(0, 3),
    Permissions: permissions,
  },
  {
    ID: "8851ae0b-d16b-49a4-93e5-35fc38e87818",
    Name: "Project Owner ",
    Description:
      "Full access at Department level. Can connect cloud accounts, manage user access, and policies.",
    UsersCount: "2",
    Users: allUsers.slice(0, 2),
    Permissions: permissions,
  },
  {
    ID: uuidv4(),
    Name: "Reports Access",
    Description: "Enables access to reports.",
    UsersCount: "3",
    Users: allUsers.slice(0, 3),
    Permissions: permissions,
  },
  {
    ID: "d3de658f-e8ab-5596-85ba-f2646831026f",
    Name: "Project User",
    Description: "Project User",
    UsersCount: "1",
    Users: allUsers.slice(0, 6),
    Permissions: permissions,
  },
];

export const roles = () => {
  return allRoles;
};
